import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { SecondaryDetailWrapper } from './styled';

const IconLoadingPlaceholder = styled(Skeleton)`
  background-color: ${colors.grey5};
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  border-radius: ${pxToRem(18)};
`;

const LabelLoadingPlaceholder = styled(Skeleton)`
  background-color: ${colors.grey5};
  width: ${pxToRem(90)};
  height: ${pxToRem(18)};
`;

export const SecondaryDetailSkeleton = () => (
  <SecondaryDetailWrapper>
    <IconLoadingPlaceholder />
    <LabelLoadingPlaceholder />
  </SecondaryDetailWrapper>
);
